/**
 * USAGE EXAMPLE - Updated Landing Component
 *
 * Replace the existing Landing component with this updated version
 * that uses the new AssetsTabView component
 */

import React, { useEffect } from "react";

import { logEvent } from "@shared/analytics/analytics";
import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AssetsKpiCards } from "./AssetsKpiCards";
import { AssetsTabView } from "./Tabs/AssetTabView";

const Landing: React.FC = () => {
  const navigate = useNavigate();

  const handleAddAsset = () => {
    logEvent("Add New Asset Clicked", {});
    navigate("/ax/asset-registry/assets/create/add");
  };

  const handleBulkAdd = () => {
    logEvent("Bulk Add Clicked", {});
    navigate("/onboarding/data-migration/data-cards");
  };

  useEffect(() => {
    logEvent("Assets Dashboard Viewed", {});
  }, []);

  return (
    <div className="space-y-6">
      {/* Header with buttons */}
      <div className="flex justify-between items-center">
        <div>
          <PageHeader
            title="Assets"
            subtitle="Manage and monitor your water system asset inventory and condition"
          />
        </div>
        <div className="flex gap-3">
          <Button variant="outline" onClick={handleBulkAdd}>
            <Plus className="h-4 w-4 mr-2" />
            Bulk Add
          </Button>
          <Button onClick={handleAddAsset}>
            <Plus className="h-4 w-4 mr-2" />
            Add New Asset
          </Button>
        </div>
      </div>

      {/* KPI Cards */}
      <AssetsKpiCards />

      {/* Tabbed Assets View - REPLACES AssetsTable */}
      <AssetsTabView />
    </div>
  );
};

export default Landing;
